import React from 'react';
import '../../../styles/accordion.css';
import './AccordionSection.css';

export interface AccordionItem {
  id: string;
  title: string | React.ReactNode;
  meta?: {
    primary?: string;
    secondary?: string;
  };
  link?: string;
  expandable?: boolean;
  expanded?: boolean;
  content?: React.ReactNode;
  onClick?: () => void;
  onHover?: (e: React.MouseEvent) => void;
  onLeave?: () => void;
}

interface AccordionSectionProps {
  title?: string;
  items: AccordionItem[];
  className?: string;
  variant?: 'default' | 'expandable' | 'hoverable';
  renderToggle?: (expanded: boolean) => React.ReactNode;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({
  title,
  items,
  className = '',
  variant = 'default',
  renderToggle
}) => {
  const renderItem = (item: AccordionItem) => {
    const ItemWrapper = item.link && !item.expandable ? 'a' : 'div';
    const wrapperProps = item.link && !item.expandable ? { href: item.link } : {};
    
    return (
      <article key={item.id} className="accordion-item">
        <ItemWrapper
          {...wrapperProps}
          className="accordion-item-link"
          onClick={item.onClick}
          onMouseEnter={item.onHover}
          onMouseLeave={item.onLeave}
        >
          <div className="accordion-item-title">
            {item.title}
          </div>
          {(item.meta?.primary || item.meta?.secondary || item.expandable) && (
            <div className="accordion-item-meta">
              {item.meta?.primary && (
                <span className="accordion-item-meta-text">{item.meta.primary}</span>
              )}
              {item.meta?.secondary && (
                <span className="accordion-item-meta-text accordion-item-meta-text--subtle">
                  {item.meta.secondary}
                </span>
              )}
              {item.expandable && renderToggle && renderToggle(item.expanded || false)}
            </div>
          )}
        </ItemWrapper>
        {item.expandable && item.expanded && item.content && (
          <div className="accordion-item-content">
            {item.content}
          </div>
        )}
      </article>
    );
  };

  return (
    <section className={`accordion-section ${className}`}>
      {title && <h2 className="accordion-section__title">{title}</h2>}
      <div className={`accordion-list accordion-list--${variant}`}>
        {items.map(renderItem)}
      </div>
    </section>
  );
};

export default AccordionSection;